var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../utils/dateUtils", "./reportBase"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DateUtils, ReportBase) {
    "use strict";
    var CdrSummaryReport = /** @class */ (function (_super) {
        __extends(CdrSummaryReport, _super);
        function CdrSummaryReport() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.reinitFilterTimer = 0;
            _this.domainDepartments = ko.observableArray();
            _this.domainExtensionsByName = ko.observableArray();
            _this.domainExtensions = ko.observableArray();
            _this.selectedDomainExtensions = ko.observableArray();
            _this.selectedDomainExtensionsByName = ko.observableArray();
            _this.selectedDomainDepartments = ko.observableArray();
            _this.filterCdrByExtension = ko.observable("");
            _this.filterApplied = ko.observable(false);
            _this.filterInProgress = ko.observable(false);
            _this.defaultDomain = "izzy.telego.com";
            return _this;
        }
        CdrSummaryReport.prototype.init = function () {
            var self = this;
            $(window).off("resize.ace_hover");
            tools.ajaxGet({
                url: "/Reports/GetExtensionsSummaryLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                        self.domainList = data.Data.lookupLists.CdrDomains;
                        self.defaultDomain = data.Data.lookupLists.DefaultDomain;
                    }
                    self.initMain();
                    ko.applyBindings(self, document.getElementById("ko-main-content"));
                    self.initRest();
                    if (!self.filterCdrByDomain()) {
                        self.filterCdrByDomain(data.Data.lookupLists.DefaultDomain);
                    }
                    self.initSummaryGrid(self.lookupLists.GridStructures.CdrSummaryReportStructure);
                    $(".loader-container").hide();
                    $("#mainContext").show();
                }
            });
        };
        CdrSummaryReport.prototype.initRest = function () {
            var self = this;
            self.filterCdrByDomain.extend({ rateLimit: 200 }).subscribe(function () {
                self.selectedDomainExtensions([]);
                self.getDomainAccounts(self.filterCdrByDomain());
                self.applyFilter();
            });
        };
        CdrSummaryReport.prototype.updateVisibleColumns = function () {
            var self = this;
            self.mainTable.removeHeadersFromHeader();
            var selectedTypes = $("input:checkbox[name=filterByType]:checked")
                .get().map(function (index, element) { return $(element).val(); });
            if (selectedTypes.indexOf("Incoming") > -1) {
                self.mainTable.getGridData().showColumn("Incoming");
            }
            else {
                self.mainTable.getGridData().hideColumn("Incoming");
            }
            if (selectedTypes.indexOf("Outgoing") > -1) {
                self.mainTable.getGridData().showColumn("Outgoing");
            }
            else {
                self.mainTable.getGridData().hideColumn("Outgoing");
            }
            if (selectedTypes.indexOf("Internal") > -1) {
                self.mainTable.getGridData().showColumn("Internal");
            }
            else {
                self.mainTable.getGridData().hideColumn("Internal");
            }
            if (selectedTypes.indexOf("Group") > -1) {
                self.mainTable.getGridData().showColumn("Queues");
            }
            else {
                self.mainTable.getGridData().hideColumn("Queues");
            }
            self.mainTable.getGridData().refresh();
            $(window).trigger("resize");
        };
        CdrSummaryReport.prototype.initSummaryGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            var nameColumn = ko.utils.arrayFirst(gridStructure.columns, function (column) {
                return column.field === "Extension";
            });
            nameColumn.template = function (dataItem) {
                var html = ""; //"<span class='label label-info'><i class='fa fa-user'></i></span>";
                html += '<a title="View Details" class="label label-info"  target="_blank" href="/Reports/CallLogs?'
                    + "extension=" + dataItem.Extension
                    + "&domain=" + self.filterCdrByDomain()
                    + "&fromdate=" + DateUtils.toIsoStringDate(self.filterCdrSummaryReportByStartDate())
                    + "&todate=" + DateUtils.toIsoStringDate(self.filterCdrSummaryReportByEndDate())
                    + '"><i class="fa fa-user" aria-hidden="true"></i></a>';
                /*if (dataItem.Extension) {
                    html += `${dataItem.Extension} ${dataItem.Department}`;
                } else {*/
                html += dataItem.Extension;
                /*}*/
                return html;
            };
            var totalColumn = ko.utils.arrayFirst(gridStructure.columns, function (column) {
                return column.field === "TotalCount";
            });
            if (totalColumn) {
                totalColumn.template = function (dataItem) {
                    var totalCount = 0;
                    var selectedTypes = $("input:checkbox[name=filterByType]:checked").get().map(function (index, element) { return $(element).val(); });
                    if (selectedTypes.indexOf("Incoming") > -1) {
                        totalCount += dataItem.TotalIncomingCount;
                    }
                    if (selectedTypes.indexOf("Outgoing") > -1) {
                        totalCount += dataItem.TotalOutgoing;
                    }
                    if (selectedTypes.indexOf("Internal") > -1) {
                        totalCount += dataItem.TotalInternal;
                    }
                    if (selectedTypes.indexOf("Group") > -1) {
                        totalCount += dataItem.TotalQueues;
                    }
                    dataItem.TotalCount = totalCount;
                    return totalCount;
                };
                totalColumn.footerTemplate = function (dataItem) {
                    var totalCount = 0;
                    var selectedTypes = $("input:checkbox[name=filterByType]:checked").get().map(function (index, element) { return $(element).val(); });
                    if (selectedTypes.indexOf("Incoming") > -1) {
                        totalCount += dataItem.TotalIncomingCount.sum;
                    }
                    if (selectedTypes.indexOf("Outgoing") > -1) {
                        totalCount += dataItem.TotalOutgoing.sum;
                    }
                    if (selectedTypes.indexOf("Internal") > -1) {
                        totalCount += dataItem.TotalInternal.sum;
                    }
                    if (selectedTypes.indexOf("Group") > -1) {
                        totalCount += dataItem.TotalQueues.sum;
                    }
                    var html = "<div class=\"text-right\"><strong>".concat(kendo.toString(totalCount, "n0"), "</strong></div>");
                    return html;
                };
            }
            self.mainTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Reports/GetExtensionsSummaryData",
                            type: "POST",
                            data: function () {
                                self.filterInProgress(true);
                                var data = {};
                                data.fromdate = DateUtils.toIsoStringDate(self.filterCdrSummaryReportByStartDate());
                                data.todate = DateUtils.toIsoStringDate(self.filterCdrSummaryReportByEndDate());
                                if (self.filterCdrByDomain()) {
                                    data.domain = self.filterCdrByDomain();
                                }
                                data.extension = self.selectedDomainExtensions().join(",");
                                var selectedEmploees = self.selectedDomainExtensionsByName().join(",");
                                if (data.extension) {
                                    if (selectedEmploees) {
                                        data.extension += "," + selectedEmploees;
                                    }
                                }
                                else {
                                    data.extension = selectedEmploees;
                                }
                                var selectedDepartments = self.selectedDomainDepartments().join(",");
                                if (data.extension) {
                                    if (selectedDepartments) {
                                        data.extension += "," + selectedDepartments;
                                    }
                                }
                                else {
                                    data.extension = selectedDepartments;
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    pageSize: 100,
                    aggregate: gridStructure.aggregate,
                    serverPaging: false,
                    serverFiltering: false,
                    serverSorting: false,
                    schema: {
                        model: gridStructure.model
                    },
                    sort: { field: "Name", dir: "asc" }
                },
                gridOptions: {
                    columns: columns,
                    autoBind: false,
                    height: "400px",
                    scrollable: true,
                    resizable: true,
                    /*pageable: true,*/
                    dataBound: function () {
                        self.renderCharts();
                    }
                },
                enableExport: {
                    entityName: "CdrSummaryReport",
                    title: "Extensions Summary Report",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: false
                },
                autoHeight: {
                    totalOffset: 222 + 90
                },
                enableStickyHeader: false,
                gridId: "tblCdrSummaryReportKendo",
                showPagerOnTop: false,
                customLoading: true,
                controller: self
            };
            self.mainTable.initGrid(gridOptions);
            self.updateVisibleColumns();
        };
        CdrSummaryReport.prototype.renderCharts = function () {
            var self = this;
            $(".outgoing-answered-percent").each(function (index, elm) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(elm);
                $(elm).kendoChart({
                    axisDefaults: self.axisDefaults,
                    legend: {
                        visible: false
                    },
                    seriesDefaults: {
                        type: "pie",
                        //startAngle: 150,
                        overlay: self.seriesDefaults.overlay
                    },
                    series: [
                        {
                            name: "Calls",
                            field: "calls",
                            colorField: "color",
                            categoryField: "extension",
                            padding: 0,
                            /*border: {
                                width: 0,
                                color: "white",
                                dashType: "solid"
                            }*/
                        }
                    ],
                    dataSource: {
                        data: [
                            {
                                calls: dataItem.OutgoingAnsweredPercent,
                                color: "#29b6f6",
                                extension: "Answered"
                            },
                            {
                                calls: 100 - dataItem.OutgoingAnsweredPercent,
                                color: "#ef5350",
                                extension: "Unanswered"
                            }
                        ]
                    },
                    valueAxis: [
                        {
                            line: {
                                visible: false
                            },
                            axisCrossingValue: 0
                        }
                    ],
                    tooltip: {
                        visible: true,
                        font: self.axisDefaults.title.font,
                        color: "white",
                        template: function (e) {
                            var value = kendo.toString(e.value, "N0");
                            return "".concat(e.category, " \u2013 ").concat(value, " %");
                        }
                    },
                    chartArea: {
                        height: 43,
                        background: "transparent"
                    }
                }).data("kendoChart");
            });
            $(".incoming-answered-percent").each(function (index, elm) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(elm);
                $(elm).kendoChart({
                    axisDefaults: self.axisDefaults,
                    legend: {
                        visible: false
                    },
                    seriesDefaults: {
                        type: "pie",
                        //startAngle: 150,
                        overlay: self.seriesDefaults.overlay
                    },
                    series: [
                        {
                            name: "Calls",
                            field: "calls",
                            colorField: "color",
                            categoryField: "extension",
                            padding: 0,
                            /*border: {
                                width: 1,
                                color: "white",
                                dashType: "solid"
                            }*/
                        }
                    ],
                    dataSource: {
                        data: [
                            {
                                calls: dataItem.IncomingAnsweredPercent,
                                color: "#66bb6a",
                                extension: "Answered"
                            },
                            {
                                calls: dataItem.IncomingMailboxPercent,
                                color: "#ffa726",
                                extension: "Mailbox"
                            },
                            {
                                calls: dataItem.IncomingMissedPercent,
                                color: "#ef5350",
                                extension: "Missed"
                            }
                        ]
                    },
                    valueAxis: [
                        {
                            line: {
                                visible: false
                            },
                            axisCrossingValue: 0
                        }
                    ],
                    tooltip: {
                        visible: true,
                        font: self.axisDefaults.title.font,
                        color: "white",
                        template: function (e) {
                            var value = kendo.toString(e.value, "N0");
                            return "".concat(e.category, " \u2013 ").concat(value, " %");
                        }
                    },
                    chartArea: {
                        height: 43,
                        background: "transparent"
                    }
                }).data("kendoChart");
            });
            $(".group-answered-percent").each(function (index, elm) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(elm);
                $(elm).kendoChart({
                    axisDefaults: self.axisDefaults,
                    legend: {
                        visible: false
                    },
                    seriesDefaults: {
                        type: "pie",
                        //startAngle: 150,
                        overlay: self.seriesDefaults.overlay
                    },
                    series: [
                        {
                            name: "Calls",
                            field: "calls",
                            colorField: "color",
                            categoryField: "extension",
                            padding: 0,
                            /*border: {
                                width: 1,
                                color: "white",
                                dashType: "solid"
                            }*/
                        }
                    ],
                    dataSource: {
                        data: [
                            {
                                calls: dataItem.QueuesAnsweredPercent,
                                color: "#66bb6a",
                                extension: "Answered"
                            },
                            {
                                calls: dataItem.QueuesMailboxPercent,
                                color: "#ffa726",
                                extension: "Mailbox"
                            },
                            {
                                calls: dataItem.QueuesMissedPercent,
                                color: "#ef5350",
                                extension: "Missed"
                            }
                        ]
                    },
                    valueAxis: [
                        {
                            line: {
                                visible: false
                            },
                            axisCrossingValue: 0
                        }
                    ],
                    tooltip: {
                        visible: true,
                        font: self.axisDefaults.title.font,
                        color: "white",
                        template: function (e) {
                            var value = kendo.toString(e.value, "N0");
                            return "".concat(e.category, " \u2013 ").concat(value, " %");
                        }
                    },
                    chartArea: {
                        height: 43,
                        background: "transparent"
                    }
                }).data("kendoChart");
            });
            $(".internal-answered-percent").each(function (index, elm) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(elm);
                $(elm).kendoChart({
                    axisDefaults: self.axisDefaults,
                    legend: {
                        visible: false
                    },
                    seriesDefaults: {
                        type: "pie",
                        //startAngle: 150,
                        overlay: self.seriesDefaults.overlay
                    },
                    series: [
                        {
                            name: "Calls",
                            field: "calls",
                            colorField: "color",
                            categoryField: "extension",
                            padding: 0,
                            /*border: {
                                width: 1,
                                color: "white",
                                dashType: "solid"
                            }*/
                        }
                    ],
                    dataSource: {
                        data: [
                            {
                                calls: dataItem.InternalAnsweredPercent,
                                color: "#66bb6a",
                                extension: "Answered"
                            },
                            {
                                calls: dataItem.InternalMailboxPercent,
                                color: "#ffa726",
                                extension: "Mailbox"
                            },
                            {
                                calls: dataItem.InternalMissedPercent,
                                color: "#ef5350",
                                extension: "Missed"
                            }
                        ]
                    },
                    valueAxis: [
                        {
                            line: {
                                visible: false
                            },
                            axisCrossingValue: 0
                        }
                    ],
                    tooltip: {
                        visible: true,
                        font: self.axisDefaults.title.font,
                        color: "white",
                        template: function (e) {
                            var value = kendo.toString(e.value, "N0");
                            return "".concat(e.category, " \u2013 ").concat(value, " %");
                        }
                    },
                    chartArea: {
                        height: 43,
                        background: "transparent"
                    }
                }).data("kendoChart");
            });
        };
        CdrSummaryReport.prototype.getDomainAccounts = function (domain) {
            var self = this;
            tools.ajaxPost({
                url: "/Reports/GetExtensionsFilterData",
                data: { domain: domain },
                success: function (data) {
                    if (data.Data) {
                        self.domainExtensions(data.Data.Extensions);
                        self.domainExtensionsByName(data.Data.ExtensionsByName);
                        self.domainDepartments(data.Data.Departments);
                    }
                }
            });
        };
        CdrSummaryReport.prototype.openFilterDialog = function () {
            $("#advancedFilterDialog").modal("show");
        };
        CdrSummaryReport.prototype.filterClicked = function () {
            var self = this;
            var extensions = $("input:checkbox[name=filterByExtension]:checked").map(function (index, element) { return $(element).val(); }).get();
            self.selectedDomainExtensions(extensions);
            var extensionsByName = $("input:checkbox[name=filterByExtensionName]:checked").map(function (index, element) { return $(element).val(); }).get();
            self.selectedDomainExtensionsByName(extensionsByName);
            var departments = $("input:checkbox[name=filterByDepartment]:checked").map(function (index, element) { return $(element).val(); }).get();
            self.selectedDomainDepartments(departments);
            self.updateVisibleColumns();
            $("#advancedFilterDialog").modal("hide");
            self.applyFilter();
        };
        CdrSummaryReport.prototype.applyFilter = function () {
            _super.prototype.applyFilter.call(this);
            var self = this;
            self.mainTable.refresh();
        };
        CdrSummaryReport.prototype.clearFilter = function () {
            _super.prototype.clearFilter.call(this);
            var self = this;
            self.period(1);
            self.filterCdrByDomain(self.defaultDomain);
            self.filterCdrByExtension("");
        };
        CdrSummaryReport.prototype.exportTo = function () {
            var self = this;
            if (self.canExport()) {
                self.mainTable.exportToMaterial();
            }
        };
        return CdrSummaryReport;
    }(ReportBase));
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Reports/ExtensionsSummary")) {
            log.log("Initialize ExtensionsSummary list");
            $(function () {
                (new CdrSummaryReport()).init();
            });
        }
    }, 0);
    return CdrSummaryReport;
});
//# sourceMappingURL=cdrsummaryreport.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/reports/cdrSummaryReport.js
// module id = 254
// module chunks = 2